import { useState } from 'react';
import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            焦点专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精心策划的追剧专题合集，按主题发现好剧不迷路
          </p>
        </div>

        <div className="space-y-6">
          {carouselItems.map((item) => (
            <CarouselCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CarouselCard({ item }: { item: typeof carouselItems[0] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group flex flex-col md:flex-row rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 hover:scale-[1.01] cursor-pointer">
      {!imgError && (
        <div className="w-full md:w-80 lg:w-96 shrink-0 overflow-hidden">
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-48 md:h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
        </div>
      )}

      <div className="flex-1 p-5 md:p-6 lg:p-8 flex flex-col justify-center">
        <div className="mb-3">
          <span className="px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-900 whitespace-nowrap">
            {item.tag}
          </span>
        </div>
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
          {item.title}
        </h3>
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
          {item.desc}
        </p>
        <div className="mt-4">
          <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 cursor-pointer">
            查看专题
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </span>
        </div>
      </div>
    </div>
  );
}